/**
 * @namespace SearchTags
 * @aka Planet.SearchTags
 */
Planet.SearchTags = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'searchTags';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'form.planet-search'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var SearchTags = function () {

    function SearchTags(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self._searchtags();
    }

    SearchTags.prototype._searchtags= function _searchtags () {
      // NOTE: Konnte mit dem Ausgabeformat nichts anfangen
      // Die gefundene Lösung ist konsequent nicht IE-kompatibel

      var $suchseite = $("#content .suchseite");

      if ($suchseite.length) {
        if ('URLSearchParams' in window) {
          var url = new URL(document.location.href);
          var params = new URLSearchParams(url.search.slice(1));
          // Die URL wird später als Tring benötigt, um die einzelnen Parameter rauszulöschen.
          var addendum = url.toString();
          // Leere Variable, die gleich gefüllt wird.
          var links = "";

          for (var p of params) {
            var parameterName = p[0];
            // Die unterschiedlichen Kategorien ausschliessen, die nicht in Tags erscheinen sollen.
            if (parameterName === "swx_sort" || parameterName === "swx_ps_q" || parameterName === "swx_yoa" || parameterName === "swx_schooltypes" || parameterName === "swx_schoolclassesfrom" || parameterName === "swx_schoolclassesto" ) {
              continue;
            }
            var parameterValue = p[1];

            // Hier wird der ursprüngliche String nur dieses einen Parameters wieder zusammengesetzt. Für später...
            var x = `&${parameterName}=${parameterValue}`;
            var inputIDSelector = `input[name="${parameterName}"][value="${parameterValue}"]`;
            var parameterInputID = $(inputIDSelector).attr("id");

            var labelSelector = `label[for="${parameterInputID}"]`;
            var parameterLabel = $(labelSelector).text();
            var parameterLabelText = $.trim(parameterLabel);

            // Hier wird die URL um den individuellen Parameter verkürzt.
            // Ein Klick auf den Link läd die Seite dann OHNE den Parameter neu.
            var newLink = addendum.replace(x, "");
            links += `<li><a href="${newLink}">${parameterLabelText}</a></li>`; // parameterValue
          }

          // Alles hübsch verpacken, damit es in die Seite kann.
          var linkwrapper = `<div class="planet-search-tags container"><ul class="search-tags-list">${links}</ul></div>`;

          // An den Anfang des Content einfügen.
          return $suchseite.prepend(linkwrapper);
        } // Feature-Test
      }

    }

    // public
    SearchTags.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    SearchTags._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new SearchTags(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return SearchTags;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    SearchTags._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      SearchTags._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = SearchTags._jQueryInterface;
  $.fn[NAME].Constructor = SearchTags;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return SearchTags._jQueryInterface;
  };

  return SearchTags;

})(window.jQuery);
